// countries.js

// Country names mapping
export const COUNTRY_NAMES = {
  USA: "United States",
  CAN: "Canada",
  MEX: "Mexico",
  GBR: "United Kingdom",
  AUS: "Australia",
  NZL: "New Zealand",
  IND: "India",
  CHN: "China",
  JPN: "Japan",
  KOR: "South Korea",
  DEU: "Germany",
  FRA: "France",
  ESP: "Spain",
  ITA: "Italy",
  NLD: "Netherlands",
  BEL: "Belgium",
  CHE: "Switzerland",
  AUT: "Austria",
  IRL: "Ireland",
  SWE: "Sweden",
  NOR: "Norway",
  DNK: "Denmark",
  FIN: "Finland",
  POL: "Poland",
  PRT: "Portugal",
  CZE: "Czech Republic",
  HUN: "Hungary",
  ROU: "Romania",
  GRC: "Greece",
  TUR: "Turkey",
  BRA: "Brazil",
  ARG: "Argentina",
  CHL: "Chile",
  COL: "Colombia",
  PER: "Peru",
  ZAF: "South Africa",
  EGY: "Egypt",
  NGA: "Nigeria",
  ARE: "United Arab Emirates",
  SAU: "Saudi Arabia",
  QAT: "Qatar",
  KWT: "Kuwait",
  SGP: "Singapore",
  MYS: "Malaysia",
  THA: "Thailand",
  VNM: "Vietnam",
  PHL: "Philippines",
  IDN: "Indonesia",
  PAK: "Pakistan",
  BGD: "Bangladesh",
  LKA: "Sri Lanka",
  NPL: "Nepal",
  JOR: "Jordan",
  ISR: "Other",
  LBN: "Lebanon",
  BMU: "Bermuda",
  Bmu: "Bermuda",
  BHR: "Bahrain",
  OMN: "Oman",
  KAZ: "Kazakhstan",
  UZB: "Uzbekistan",
  TJK: "Tajikistan",
  RUS: "Russia",
  UKR: "Ukraine",
  IRN: "Iran",
  IRQ: "Iraq",
  AFG: "Afghanistan",
  MMR: "Myanmar",
  HKG: "Hong Kong",
  TWN: "Taiwan",  
};

export const COUNTRY_SHORT_NAMES = {
  "United States": "USA",
  "Canada": "CAN",
  "Mexico": "MEX",
  "United Kingdom": "GBR",
  "Australia": "AUS",
  "New Zealand": "NZL",
  "India": "IND",
  "China": "CHN",
  "Japan": "JPN",
  "South Korea": "KOR",
  "Germany": "DEU",
  "France": "FRA",
  "Spain": "ESP",
  "Italy": "ITA",
  "Netherlands": "NLD",
  "Belgium": "BEL",
  "Switzerland": "CHE",
  "Austria": "AUT",
  "Ireland": "IRL",
  "Sweden": "SWE",
  "Norway": "NOR",
  "Denmark": "DNK",
  "Finland": "FIN",
  "Poland": "POL",
  "Portugal": "PRT",
  "Czech Republic": "CZE",
  "Hungary": "HUN",
  "Romania": "ROU",
  "Greece": "GRC",
  "Turkey": "TUR",
  "Brazil": "BRA",
  "Argentina": "ARG",
  "Chile": "CHL",
  "Colombia": "COL",
  "Peru": "PER",
  "South Africa": "ZAF",
  "Egypt": "EGY",
  "Nigeria": "NGA",
  "United Arab Emirates": "ARE",
  "Saudi Arabia": "SAU",
  "Qatar": "QAT",
  "Kuwait": "KWT",
  "Singapore": "SGP",
  "Malaysia": "MYS",
  "Thailand": "THA",
  "Vietnam": "VNM",
  "Philippines": "PHL",
  "Indonesia": "IDN",
  "Pakistan": "PAK",
  "Bangladesh": "BGD",
  "Sri Lanka": "LKA",
  "Nepal": "NPL",
  "Jordan": "JOR",
  "Other": "ISR",
  "Lebanon": "LBN",
  "Bermuda": "BMU",
  "Bahrain": "BHR",
  "Oman": "OMN",
  "Kazakhstan": "KAZ",
  "Uzbekistan": "UZB",
  "Tajikistan": "TJK",
  "Russia": "RUS",
  "Ukraine": "UKR",
  "Iran": "IRN",
  "Iraq": "IRQ",
  "Afghanistan": "AFG",
  "Myanmar": "MMR",
  "Hong Kong": "HKG",
  "Taiwan": "TWN",
};

// States/Provinces for each country
export const COUNTRY_STATES = {
  USA: [
    { code: "AL", name: "Alabama" },
    { code: "AK", name: "Alaska" },
    { code: "AZ", name: "Arizona" },
    { code: "AR", name: "Arkansas" },
    { code: "CA", name: "California" },
    { code: "CO", name: "Colorado" },
    { code: "CT", name: "Connecticut" },
    { code: "DE", name: "Delaware" },
    { code: "FL", name: "Florida" },
    { code: "GA", name: "Georgia" },
    { code: "HI", name: "Hawaii" },
    { code: "ID", name: "Idaho" },
    { code: "IL", name: "Illinois" },
    { code: "IN", name: "Indiana" },
    { code: "IA", name: "Iowa" },
    { code: "KS", name: "Kansas" },
    { code: "KY", name: "Kentucky" },
    { code: "LA", name: "Louisiana" },
    { code: "ME", name: "Maine" },
    { code: "MD", name: "Maryland" },
    { code: "MA", name: "Massachusetts" },
    { code: "MI", name: "Michigan" },
    { code: "MN", name: "Minnesota" },
    { code: "MS", name: "Mississippi" },
    { code: "MO", name: "Missouri" },
    { code: "MT", name: "Montana" },
    { code: "NE", name: "Nebraska" },
    { code: "NV", name: "Nevada" },
    { code: "NH", name: "New Hampshire" },
    { code: "NJ", name: "New Jersey" },
    { code: "NM", name: "New Mexico" },
    { code: "NY", name: "New York" },
    { code: "NC", name: "North Carolina" },
    { code: "ND", name: "North Dakota" },
    { code: "OH", name: "Ohio" },
    { code: "OK", name: "Oklahoma" },
    { code: "OR", name: "Oregon" },
    { code: "PA", name: "Pennsylvania" },
    { code: "RI", name: "Rhode Island" },
    { code: "SC", name: "South Carolina" },
    { code: "SD", name: "South Dakota" },
    { code: "TN", name: "Tennessee" },
    { code: "TX", name: "Texas" },
    { code: "UT", name: "Utah" },
    { code: "VT", name: "Vermont" },
    { code: "VA", name: "Virginia" },
    { code: "WA", name: "Washington" },
    { code: "WV", name: "West Virginia" },
    { code: "WI", name: "Wisconsin" },
    { code: "WY", name: "Wyoming" },
    { code: "DC", name: "District of Columbia" },
  ],

  CAN: [
    { code: "AB", name: "Alberta" },
    { code: "BC", name: "British Columbia" },
    { code: "MB", name: "Manitoba" },
    { code: "NB", name: "New Brunswick" },
    { code: "NL", name: "Newfoundland and Labrador" },
    { code: "NS", name: "Nova Scotia" },
    { code: "NT", name: "Northwest Territories" },
    { code: "NU", name: "Nunavut" },
    { code: "ON", name: "Ontario" },
    { code: "PE", name: "Prince Edward Island" },
    { code: "QC", name: "Quebec" },
    { code: "SK", name: "Saskatchewan" },
    { code: "YT", name: "Yukon" },
  ],

  MEX: [
    { code: "AGU", name: "Aguascalientes" },
    { code: "BCN", name: "Baja California" },
    { code: "BCS", name: "Baja California Sur" },
    { code: "CAM", name: "Campeche" },
    { code: "CHP", name: "Chiapas" },
    { code: "CHH", name: "Chihuahua" },
    { code: "COA", name: "Coahuila" },
    { code: "COL", name: "Colima" },
    { code: "CMX", name: "Ciudad de México" },
    { code: "DUR", name: "Durango" },
    { code: "GUA", name: "Guanajuato" },
    { code: "GRO", name: "Guerrero" },
    { code: "HID", name: "Hidalgo" },
    { code: "JAL", name: "Jalisco" },
    { code: "MEX", name: "México" },
    { code: "MIC", name: "Michoacán" },
    { code: "MOR", name: "Morelos" },
    { code: "NAY", name: "Nayarit" },
    { code: "NLE", name: "Nuevo León" },
    { code: "OAX", name: "Oaxaca" },
    { code: "PUE", name: "Puebla" },
    { code: "QUE", name: "Querétaro" },
    { code: "ROO", name: "Quintana Roo" },
    { code: "SLP", name: "San Luis Potosí" },
    { code: "SIN", name: "Sinaloa" },
    { code: "SON", name: "Sonora" },
    { code: "TAB", name: "Tabasco" },
    { code: "TAM", name: "Tamaulipas" },
    { code: "TLA", name: "Tlaxcala" },
    { code: "VER", name: "Veracruz" },
    { code: "YUC", name: "Yucatán" },
    { code: "ZAC", name: "Zacatecas" },
  ],

  GBR: [
    { code: "ENG", name: "England" },
    { code: "SCT", name: "Scotland" },
    { code: "WLS", name: "Wales" },
    { code: "NIR", name: "Northern Ireland" },
  ],

  AUS: [
    { code: "NSW", name: "New South Wales" },
    { code: "VIC", name: "Victoria" },
    { code: "QLD", name: "Queensland" },
    { code: "WA", name: "Western Australia" },
    { code: "SA", name: "South Australia" },
    { code: "TAS", name: "Tasmania" },
    { code: "ACT", name: "Australian Capital Territory" },
    { code: "NT", name: "Northern Territory" },
  ],

  IND: [
    { code: "AN", name: "Andaman and Nicobar Islands" },
    { code: "AP", name: "Andhra Pradesh" },
    { code: "AR", name: "Arunachal Pradesh" },
    { code: "AS", name: "Assam" },
    { code: "BR", name: "Bihar" },
    { code: "CH", name: "Chandigarh" },
    { code: "CT", name: "Chhattisgarh" },
    { code: "DN", name: "Dadra and Nagar Haveli" },
    { code: "DD", name: "Daman and Diu" },
    { code: "DL", name: "Delhi" },
    { code: "GA", name: "Goa" },
    { code: "GJ", name: "Gujarat" },
    { code: "HR", name: "Haryana" },
    { code: "HP", name: "Himachal Pradesh" },
    { code: "JK", name: "Jammu and Kashmir" },
    { code: "JH", name: "Jharkhand" },
    { code: "KA", name: "Karnataka" },
    { code: "KL", name: "Kerala" },
    { code: "LA", name: "Ladakh" },
    { code: "LD", name: "Lakshadweep" },
    { code: "MP", name: "Madhya Pradesh" },
    { code: "MH", name: "Maharashtra" },
    { code: "MN", name: "Manipur" },
    { code: "ML", name: "Meghalaya" },
    { code: "MZ", name: "Mizoram" },
    { code: "NL", name: "Nagaland" },
    { code: "OR", name: "Odisha" },
    { code: "PY", name: "Puducherry" },
    { code: "PB", name: "Punjab" },
    { code: "RJ", name: "Rajasthan" },
    { code: "SK", name: "Sikkim" },
    { code: "TN", name: "Tamil Nadu" },
    { code: "TG", name: "Telangana" },
    { code: "TR", name: "Tripura" },
    { code: "UP", name: "Uttar Pradesh" },
    { code: "UT", name: "Uttarakhand" },
    { code: "WB", name: "West Bengal" },
  ],

  CHN: [
    { code: "AH", name: "Anhui" },
    { code: "BJ", name: "Beijing" },
    { code: "CQ", name: "Chongqing" },
    { code: "FJ", name: "Fujian" },
    { code: "GS", name: "Gansu" },
    { code: "GD", name: "Guangdong" },
    { code: "GX", name: "Guangxi" },
    { code: "GZ", name: "Guizhou" },
    { code: "HI", name: "Hainan" },
    { code: "HE", name: "Hebei" },
    { code: "HL", name: "Heilongjiang" },
    { code: "HA", name: "Henan" },
    { code: "HB", name: "Hubei" },
    { code: "HN", name: "Hunan" },
    { code: "JS", name: "Jiangsu" },
    { code: "JX", name: "Jiangxi" },
    { code: "JL", name: "Jilin" },
    { code: "LN", name: "Liaoning" },
    { code: "NM", name: "Inner Mongolia" },
    { code: "NX", name: "Ningxia" },
    { code: "QH", name: "Qinghai" },
    { code: "SN", name: "Shaanxi" },
    { code: "SD", name: "Shandong" },
    { code: "SH", name: "Shanghai" },
    { code: "SX", name: "Shanxi" },
    { code: "SC", name: "Sichuan" },
    { code: "TJ", name: "Tianjin" },
    { code: "XJ", name: "Xinjiang" },
    { code: "XZ", name: "Tibet" },
    { code: "YN", name: "Yunnan" },
    { code: "ZJ", name: "Zhejiang" },
  ],

  DEU: [
    { code: "BW", name: "Baden-Württemberg" },
    { code: "BY", name: "Bavaria" },
    { code: "BE", name: "Berlin" },
    { code: "BB", name: "Brandenburg" },
    { code: "HB", name: "Bremen" },
    { code: "HH", name: "Hamburg" },
    { code: "HE", name: "Hesse" },
    { code: "MV", name: "Mecklenburg-Vorpommern" },
    { code: "NI", name: "Lower Saxony" },
    { code: "NW", name: "North Rhine-Westphalia" },
    { code: "RP", name: "Rhineland-Palatinate" },
    { code: "SL", name: "Saarland" },
    { code: "SN", name: "Saxony" },
    { code: "ST", name: "Saxony-Anhalt" },
    { code: "SH", name: "Schleswig-Holstein" },
    { code: "TH", name: "Thuringia" },
  ],

  FRA: [
    { code: "ARA", name: "Auvergne-Rhône-Alpes" },
    { code: "BFC", name: "Bourgogne-Franche-Comté" },
    { code: "BRE", name: "Brittany" },
    { code: "CVL", name: "Centre-Val de Loire" },
    { code: "COR", name: "Corsica" },
    { code: "GES", name: "Grand Est" },
    { code: "HDF", name: "Hauts-de-France" },
    { code: "IDF", name: "Île-de-France" },
    { code: "NOR", name: "Normandy" },
    { code: "NAQ", name: "Nouvelle-Aquitaine" },
    { code: "OCC", name: "Occitanie" },
    { code: "PDL", name: "Pays de la Loire" },
    { code: "PAC", name: "Provence-Alpes-Côte d'Azur" },
  ],

  BRA: [
    { code: "AC", name: "Acre" },
    { code: "AL", name: "Alagoas" },
    { code: "AP", name: "Amapá" },
    { code: "AM", name: "Amazonas" },
    { code: "BA", name: "Bahia" },
    { code: "CE", name: "Ceará" },
    { code: "DF", name: "Distrito Federal" },
    { code: "ES", name: "Espírito Santo" },
    { code: "GO", name: "Goiás" },
    { code: "MA", name: "Maranhão" },
    { code: "MT", name: "Mato Grosso" },
    { code: "MS", name: "Mato Grosso do Sul" },
    { code: "MG", name: "Minas Gerais" },
    { code: "PA", name: "Pará" },
    { code: "PB", name: "Paraíba" },
    { code: "PR", name: "Paraná" },
    { code: "PE", name: "Pernambuco" },
    { code: "PI", name: "Piauí" },
    { code: "RJ", name: "Rio de Janeiro" },
    { code: "RN", name: "Rio Grande do Norte" },
    { code: "RS", name: "Rio Grande do Sul" },
    { code: "RO", name: "Rondônia" },
    { code: "RR", name: "Roraima" },
    { code: "SC", name: "Santa Catarina" },
    { code: "SP", name: "São Paulo" },
    { code: "SE", name: "Sergipe" },
    { code: "TO", name: "Tocantins" },
  ],

  JPN: [
    { code: "01", name: "Hokkaido" },
    { code: "02", name: "Aomori" },
    { code: "03", name: "Iwate" },
    { code: "04", name: "Miyagi" },
    { code: "05", name: "Akita" },
    { code: "06", name: "Yamagata" },
    { code: "07", name: "Fukushima" },
    { code: "08", name: "Ibaraki" },
    { code: "09", name: "Tochigi" },
    { code: "10", name: "Gunma" },
    { code: "11", name: "Saitama" },
    { code: "12", name: "Chiba" },
    { code: "13", name: "Tokyo" },
    { code: "14", name: "Kanagawa" },
    { code: "15", name: "Niigata" },
    { code: "16", name: "Toyama" },
    { code: "17", name: "Ishikawa" },
    { code: "18", name: "Fukui" },
    { code: "19", name: "Yamanashi" },
    { code: "20", name: "Nagano" },
    { code: "21", name: "Gifu" },
    { code: "22", name: "Shizuoka" },
    { code: "23", name: "Aichi" },
    { code: "24", name: "Mie" },
    { code: "25", name: "Shiga" },
    { code: "26", name: "Kyoto" },
    { code: "27", name: "Osaka" },
    { code: "28", name: "Hyogo" },
    { code: "29", name: "Nara" },
    { code: "30", name: "Wakayama" },
    { code: "31", name: "Tottori" },
    { code: "32", name: "Shimane" },
    { code: "33", name: "Okayama" },
    { code: "34", name: "Hiroshima" },
    { code: "35", name: "Yamaguchi" },
    { code: "36", name: "Tokushima" },
    { code: "37", name: "Kagawa" },
    { code: "38", name: "Ehime" },
    { code: "39", name: "Kochi" },
    { code: "40", name: "Fukuoka" },
    { code: "41", name: "Saga" },
    { code: "42", name: "Nagasaki" },
    { code: "43", name: "Kumamoto" },
    { code: "44", name: "Oita" },
    { code: "45", name: "Miyazaki" },
    { code: "46", name: "Kagoshima" },
    { code: "47", name: "Okinawa" },
  ],

  ESP: [
    { code: "AN", name: "Andalusia" },
    { code: "AR", name: "Aragon" },
    { code: "AS", name: "Asturias" },
    { code: "IB", name: "Balearic Islands" },
    { code: "PV", name: "Basque Country" },
    { code: "CN", name: "Canary Islands" },
    { code: "CB", name: "Cantabria" },
    { code: "CL", name: "Castile and León" },
    { code: "CM", name: "Castilla-La Mancha" },
    { code: "CT", name: "Catalonia" },
    { code: "EX", name: "Extremadura" },
    { code: "GA", name: "Galicia" },
    { code: "MD", name: "Madrid" },
    { code: "MC", name: "Murcia" },
    { code: "NC", name: "Navarre" },
    { code: "RI", name: "La Rioja" },
    { code: "VC", name: "Valencia" },
  ],

  ITA: [
    { code: "65", name: "Abruzzo" },
    { code: "77", name: "Basilicata" },
    { code: "78", name: "Calabria" },
    { code: "72", name: "Campania" },
    { code: "45", name: "Emilia-Romagna" },
    { code: "36", name: "Friuli Venezia Giulia" },
    { code: "62", name: "Lazio" },
    { code: "42", name: "Liguria" },
    { code: "25", name: "Lombardy" },
    { code: "57", name: "Marche" },
    { code: "67", name: "Molise" },
    { code: "21", name: "Piedmont" },
    { code: "75", name: "Apulia" },
    { code: "88", name: "Sardinia" },
    { code: "82", name: "Sicily" },
    { code: "52", name: "Tuscany" },
    { code: "32", name: "Trentino-Alto Adige" },
    { code: "55", name: "Umbria" },
    { code: "23", name: "Aosta Valley" },
    { code: "34", name: "Veneto" },
  ],

  ARE: [
    { code: "AZ", name: "Abu Dhabi" },
    { code: "AJ", name: "Ajman" },
    { code: "DU", name: "Dubai" },
    { code: "FU", name: "Fujairah" },
    { code: "RK", name: "Ras Al Khaimah" },
    { code: "SH", name: "Sharjah" },
    { code: "UQ", name: "Umm Al Quwain" },
  ],

  SAU: [
    { code: "01", name: "Riyadh" },
    { code: "02", name: "Makkah" },
    { code: "03", name: "Madinah" },
    { code: "04", name: "Eastern Province" },
    { code: "05", name: "Qassim" },
    { code: "06", name: "Ha'il" },
    { code: "07", name: "Tabuk" },
    { code: "08", name: "Northern Borders" },
    { code: "09", name: "Jazan" },
    { code: "10", name: "Najran" },
    { code: "11", name: "Al-Bahah" },
    { code: "12", name: "Al-Jawf" },
    { code: "14", name: "Asir" },
  ],

  PAK: [
    { code: "PB", name: "Punjab" },
    { code: "SD", name: "Sindh" },
    { code: "KP", name: "Khyber Pakhtunkhwa" },
    { code: "BA", name: "Balochistan" },
    { code: "IS", name: "Islamabad Capital Territory" },
    { code: "GB", name: "Gilgit-Baltistan" },
    { code: "AK", name: "Azad Kashmir" },
  ],

  NZL: [
    { code: "AUK", name: "Auckland" },
    { code: "BOP", name: "Bay of Plenty" },
    { code: "CAN", name: "Canterbury" },
    { code: "GIS", name: "Gisborne" },
    { code: "HKB", name: "Hawke's Bay" },
    { code: "MWT", name: "Manawatu-Wanganui" },
    { code: "MBH", name: "Marlborough" },
    { code: "NSN", name: "Nelson" },
    { code: "NTL", name: "Northland" },
    { code: "OTA", name: "Otago" },
    { code: "STL", name: "Southland" },
    { code: "TKI", name: "Taranaki" },
    { code: "TAS", name: "Tasman" },
    { code: "WKO", name: "Waikato" },
    { code: "WGN", name: "Wellington" },
    { code: "WTC", name: "West Coast" },
  ],

  ZAF: [
    { code: "EC", name: "Eastern Cape" },
    { code: "FS", name: "Free State" },
    { code: "GP", name: "Gauteng" },
    { code: "KZN", name: "KwaZulu-Natal" },
    { code: "LP", name: "Limpopo" },
    { code: "MP", name: "Mpumalanga" },
    { code: "NC", name: "Northern Cape" },
    { code: "NW", name: "North West" },
    { code: "WC", name: "Western Cape" },
  ],

  BMU: [
    { code: "DEV", name: "Devonshire" },
    { code: "HAM", name: "Hamilton" },
    { code: "PAG", name: "Paget" },
    { code: "PEM", name: "Pembroke" },
    { code: "SGE", name: "St. George's" },
    { code: "SAN", name: "Sandys" },
    { code: "SMI", name: "Smith's" },
    { code: "SOU", name: "Southampton" },
    { code: "WAR", name: "Warwick" },
  ],

  // Countries without states/provinces (city-states or small countries)
  SGP: [],
  QAT: [],
  KWT: [],
  BHR: [],
  BMU: [],
  LBN: [],
};

// Helper functions
export const getCountryName = (code) => {
  return COUNTRY_NAMES[code] || code;
};

export const getStates = (countryCode) => {
  return COUNTRY_STATES[countryCode] || [];
};

export const getStateName = (countryCode, stateCode) => {
  const states = COUNTRY_STATES[countryCode] || [];
  const state = states.find((s) => s.code === stateCode);
  return state ? state.name : stateCode;
};

export const hasStates = (countryCode) => {
  const states = COUNTRY_STATES[countryCode];
  return states && states.length > 0;
};

// Get countries as array for dropdowns
export const getCountriesArray = () => {
  return Object.entries(COUNTRY_NAMES).map(([code, name]) => ({
    code,
    name,
  }));
};

// Default export for backward compatibility
export default COUNTRY_NAMES;